import type { Environment } from "./Environment"

const environmentPatterns: Record<Environment, RegExp> = {
	dev: /finder-k\.porsche\.(com|cn)/,
	local: /localhost/,
	preview: /finder-preview\.porsche\.(com|cn)/,
	prod: /finder\.porsche\.(com|cn)/,
}

/**
 * Parses the path to find the Environment of the application.
 * @param path The path that should be parsed.
 * @returns The current Environment. Returns null of the environment is unknown, like localhost or other dev stages.
 */
export function parseEnvironment(path: string): Environment | null {
	for (const key of Object.keys(environmentPatterns) as Environment[]) {
		const matcher = environmentPatterns[key]
		const matches = matcher.exec(path)
		if (matches) {
			return key
		}
	}
	return null
}
